import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { deleteOrder } from '../../actions/orderActions';
import { formatNumber } from '../../utils/orderService';
import { text16 } from '../Styles/index';

const Warning = styled.div`
  background-color: rgba(244, 67, 54,.25);
  padding: 16px;
  color: #C62828;
  border-radius: 4px;
  margin-bottom: 24px
`


const DeleteDialog = (props) => (
  <Dialog
    title="Delete Order"
    actions={props.actions}
    modal={false}
    open={props.open}
    onRequestClose={props.handleClose}
  >
    <div style={{ marginBottom: '24px' }}>
      Product Code: {props.order.key}
    </div>
    <Warning>
      After you delete an order, it's permanently deleted. Orders can't be undeleted.
    </Warning>
    <div>
      <pre style={{ width: '100%', backgroundColor: '#dfdfff', color: '#333', padding: "8px 16px", borderRadius: "4px", overflow: 'auto' }}>
        <code style={{ lineHeight: 1.25 }}>
          {`${JSON.stringify(props.order, undefined, 2)}`}
        </code>
      </pre>
    </div>
  </Dialog>
)


class OrdersTable extends Component {
  state = {
    fixedHeader: true,
    fixedFooter: true,
    stripedRows: false,
    showRowHover: false,
    selectable: false,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    height: `${56 + this.props.height}px`,

    openDialog: false,
    orderToDelete: {},

  }

  _handleDialogCloseRequest = event => {
    this.setState({
      openDialog: false,
      orderToDelete: {}
    })
  }

  _handleDialogOpenRequest = (event, product) => {
    this.setState({
      openDialog: true,
      orderToDelete: product
    })
  }

  _dialogActions(){
    return [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this._handleDialogCloseRequest}
      />,
      <form style={{display: 'inline-block'}} onSubmit={this._handleDeleteProduct}>
        <RaisedButton
          label="Delete"
          type="submit"
          backgroundColor="#F44336"
          labelStyle={{ color: 'white' }}
        />
      </form>,
    ]
  }

  _calculateAmount(products){
    let amount = 0;
    for (const key in products) {
      amount += products[key];
    }
    return amount;
  }

  _handleDeleteProduct = event => {
    event.preventDefault();
    this.props.deleteOrder({ key: this.state.orderToDelete.key })
    .then(_ => {
      if (this.props.order.status === 'deleted') {
        this.props.refreshPage();
      }
    })
    this.setState({
      openDialog: false,
    })
  }


  render() {
    return (
      <div>
        <Table
          style={{tableLayout: 'auto'}}
          bodyStyle= {{ overflowX: undefined, overflowY: undefined }}
          height={this.state.height}
          fixedFooter={this.state.fixedFooter}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
        >
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
            <TableRow>
              <TableHeaderColumn tooltip={"#"}>#</TableHeaderColumn>
              {this.props.headers.map((header, index) => {
                return <TableHeaderColumn key={index} style={{textAlign: index === 2 ? 'right': ''}} tooltip={header}>{header}</TableHeaderColumn>
              })}
            </TableRow>
            {this.props.tableData.map( (row, index) => (
              <TableRow key={index} style={{ opacity: row.active ? .5 : 1 }}>
                <TableRowColumn style={text16}>{row.no}</TableRowColumn>
                <TableRowColumn style={text16}>{row.number}</TableRowColumn>
                <TableRowColumn style={text16}>{(new Date(row.date)).toDateString()}</TableRowColumn>
                {row.amount !== undefined && <TableRowColumn style={{...text16, textAlign: 'right'}}>{formatNumber(row.amount)} L</TableRowColumn>}
                <TableRowColumn style={text16}>{row.client.name}</TableRowColumn>
                <TableRowColumn style={text16}>{row.status}</TableRowColumn>
                <TableRowColumn style={text16}>{row.active ? 'In Cart' : 'Competed'}</TableRowColumn>
                <TableRowColumn>{row.notes}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'right'}}>
                  <RaisedButton label="Edit"
                    labelStyle={{height: 'auto', color: 'white'}} 
                    backgroundColor="#4CAF50" 
                    onTouchTap={(event) => this.props.editHandler(row.key)} />
                  <span style={{width: '8px', display: 'inline-block'}}></span>
                  <RaisedButton label="Delete" 
                    labelStyle={{height: 'auto', color: 'white'}} 
                    backgroundColor="#F44336" 
                    onTouchTap={event => this._handleDialogOpenRequest(event, row)} />
                </TableRowColumn>
              </TableRow>
              ))}
          </TableBody>
        </Table>
        <div>
          <DeleteDialog
            open={this.state.openDialog}
            actions={this._dialogActions()}
            handleClose={this._handleDialogCloseRequest}
            order={this.state.orderToDelete}></DeleteDialog>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ order: state.order.deleted });
const mapDispatchToProps = { deleteOrder };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrdersTable));



// WEBPACK FOOTER //
// ./src/components/Orders/OrderTable.js